// tslint:disable:no-console

export function reportError(err: Error) {
  console.warn("ERROR", err);
}
